import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client';
import type { ModelCatalogEntry } from '@/lib/api/types';

export function useModels() {
  return useQuery({
    queryKey: ['models'],
    queryFn: () => apiFetch<ModelCatalogEntry[]>('/models'),
  });
}
